import { IdTokenResult, ParsedToken } from "firebase/auth";

import { GOSTUDENT_SUBSCRIPTION_NAME } from "@seneca/subscriptions-service-consts";

import { getFirebaseAuth } from "services/firebase/auth";

type GoStudentIdTokenResult = IdTokenResult & {
  claims: ParsedToken & {
    firebase: ParsedToken["firebase"] & {
      sign_in_attributes?: {
        extra_info?: {
          subscriptions?: {
            gostudent_learning?: string[];
          };
        };
      };
    };
  };
};

export default async function isGoStudentSubscriptionInToken() {
  const token = await getFirebaseAuth().currentUser?.getIdTokenResult();

  const isImpersonationToken =
    token?.claims.firebase?.sign_in_provider === "custom";
  if (isImpersonationToken) {
    return true;
  }

  return !!(
    token as GoStudentIdTokenResult
  )?.claims?.firebase?.sign_in_attributes?.extra_info?.subscriptions?.gostudent_learning?.includes(
    GOSTUDENT_SUBSCRIPTION_NAME
  );
}
